import React from "react";
import { toElementProps } from "../../Element";
import useLoremIpsum from "../technical/useLoremIpsum.jsx";

export function StepStyles(params = {}) {
    const { palette, MobileBreakpoint } = params;
    const { initial, initialText } = palette.primary;

    return {
        "& .step": {
            display: "grid",
            gridGap: "16px",
            gridTemplateRows: "max-content 1fr",
            width: "320px",
            padding: "15px",
            backgroundColor: palette.primary.initial,
            color: palette.primary.initialText,

            pointerEvents: "none",

            "& .step-texts": {
                display: "grid",
                gridGap: "16px",
                wordBreak: "break-word",

                "& .step-header": {},
                "& .step-text": {},
            },

            [MobileBreakpoint]: {
                display: "flex",
                width: "100% !important",
            },
        },

        "& .length-2, .length-4": {
            width: "590px",
        },

        // ----- Variant 1 -----
        "& .step-variant-1": {
            color: initialText,
            backgroundColor: initial,
            borderRadius: "20px",
        },

        // ----- Variant 2 -----
        "& .step-variant-2": {
            backgroundColor: "#ffffff",
            color: initialText,
            border: `4px solid ${initial}`,
            borderRadius: "20px",
        },

        // ----- Variant 3 -----
        "& .step-variant-3": {
            backgroundColor: "#ffffff",
            color: initialText,
            border: `8px solid ${initial}`,
        },

        // ----- Variant 4 -----
        "& .step-variant-4": {
            backgroundColor: initial,
            color: initialText,
        },
    };
}

export default function Step(props) {
    const LI = useLoremIpsum();

    const { header, text, length } = props;

    if (!header && !text) {
        return null;
    }

    const variant = props.variant || 1;
    const CNSteps = ["step", `step-variant-${variant}`, `length-${length}`];
    const elProps = toElementProps(props, { className: CNSteps });

    return (
        <div {...elProps}>
            <div className="step-texts">
                <h2 className="step-header">{header || LI.Steps[0].header}</h2>
                <div className="step-text">{text || LI.Steps[0].text}</div>
            </div>
        </div>
    );
}
